module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"TallGeni","subtitle":"Bli lynrask i hoderegning"},"en":{"title":"CalculationGenius","subtitle":"Super-fast mental calculation"}}')
  delete Component.options._Ctor
}
